import { Base, Component, Emit, Prop } from '@/vue-property-decorator'
import { GlobalConst } from '@/context'
import { Menu, Row } from '@/plugins/ant-design-vue/tsx-support'
import { createSvgSprite } from '@/utils/business-utils/assets'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import style from '../style.module.scss'

import { CanClickWhenForceBind } from '@/views/center/security/store'
import { Currency } from '@/config/currencies.config'
import { CurrencyEnum, CurrencyInfos } from '@/api/common/type'
import { getURLParameters, replaceRouteQuery } from '@/utils/Route'
import Skin from '@/controller/Skin'

interface Props {
  showIcon?: boolean
}
/**
 * 币种选项列表 因为H5是弹窗形式PC是下拉形式，所以抽成独立组件复用
 * */
@Component<SwitchCurrencyOptions>({
  name: 'SwitchCurrencyOptions'
})
export default class SwitchCurrencyOptions extends Base<Props> {
  @Prop({ default: false })
  readonly showIcon?: Props['showIcon']

  @Emit('selected')
  private selected() {
    return
  }

  @Emit('loadState')
  private loadState(load = false) {
    return load
  }

  get selectedKeys() {
    const { userInfos } = useMainStore()
    return [userInfos?.currency]
  }
  private get tryCurrencyConfig() {
    const { siteInfos } = useMainStore()
    return {
      /**
       * 当前站点货币列表
       */
      currencyInfos: siteInfos?.currencyInfos || []
    }
  }

  /** 监听语言切换 */

  /**监听币种切换回调 */
  private async handlerCurrencyChange(selected: Record<'key', string>) {
    this.loadState(true)
    const { updateCurrentTryCurrency } = useMainStore()
    const config = this.tryCurrencyConfig.currencyInfos.find(
      (item) => item.currencyCode === selected.key
    )
    if (config) {
      await updateCurrentTryCurrency(config)
      //更新url参数
      const queryParams = getURLParameters()
      replaceRouteQuery(this.$route.query, {
        ...queryParams,
        currency: config.currencyCode
      })
    }
    this.loadState(false)
    this.selected()
    window.location.reload()
  }

  private renderItem(params: {
    currency: CurrencyInfos
    showIcon?: boolean
    showName?: boolean
    iconSize?: number
  }) {
    const { currency, showIcon, showName, iconSize } = params
    const currencyIconMap = Currency.registerIconMap()
    const { isWeb, language, hasLogined } = useMainStore()
    const { isStake } = Skin.currentTheme()
    const { t } = useI18n()

    const currencyItem =
      currencyIconMap[
        (currency.currencyType === CurrencyEnum.CRYPTO
          ? currency.currencyDisplay
          : currency.currencyCode) as unknown as keyof typeof currencyIconMap
      ]

    const icon = currencyItem?.icon
    const width = isWeb ? (isStake ? 20 : 28) : isStake ? 26 : 36
    const scale = iconSize ? iconSize / icon?.width : width / icon?.width
    return (
      <Row.Tsx
        title={''}
        class={[style.item, CanClickWhenForceBind]}
        type={'flex'}
        align={'middle'}
      >
        {hasLogined ? (
          <my-img
            class={[style['icon-box-head'], 'switch-lang__icon']}
            src={'/lobby_asset/common/common/_sprite/img_hb_frame.png'}
            options={{
              type: 'div'
            }}
          >
            <icon-sprite scale={scale} sprite={icon} />
          </my-img>
        ) : (
          <div class={[style['icon-box-head'], 'switch-lang__icon']}>
            <icon-sprite scale={scale} sprite={icon} />
          </div>
        )}

        {currency.currencyType === CurrencyEnum.CRYPTO ? (
          <span
            class={{
              [GlobalConst.CssClassName.Lobby.Ellipsis]: true,
              'switch-lang__text': true
            }}
          >
            {language === 'zh_CN' &&
              currency.marketCurrencyCode.includes('BTC') &&
              t('lobby.modal.currency.BTC')}
            {language === 'zh_CN' &&
              currency.marketCurrencyCode.includes('ETH') &&
              t('lobby.modal.currency.ETH')}
            {currency.currencyDisplay}
            {showName ? `（${currencyItem?.title}）` : ''}
          </span>
        ) : (
          <span
            class={{
              [GlobalConst.CssClassName.Lobby.Ellipsis]: true,
              'switch-lang__text': true
            }}
          >
            {showName
              ? `${currencyItem?.title}（${currency?.currencyCode}）`
              : currency?.currencyCode}
          </span>
        )}

        {showIcon && (
          <div
            class={{
              [style.cicle]: true,
              ['cicle']: true
            }}
          >
            <icon-sprite sprite={createSvgSprite('comm_icon_gou')} />
          </div>
        )}
      </Row.Tsx>
    )
  }

  render() {
    return (
      <Menu.Tsx
        class={style.menu}
        selectable
        selected-keys={this.selectedKeys}
        onClick={this.handlerCurrencyChange}
      >
        {this.tryCurrencyConfig.currencyInfos.map((item: CurrencyInfos) => {
          return (
            <Menu.Item.Tsx key={item.currencyCode} class={style.switchItem}>
              {this.renderItem({
                currency: item,
                showIcon: this.showIcon,
                showName: true,
                iconSize: this.showIcon ? 30 : 0
              })}
            </Menu.Item.Tsx>
          )
        })}
      </Menu.Tsx>
    )
  }
}
